class LuminairBundle extends HTMLElement {
  connectedCallback() {
    this.lines = [...this.querySelectorAll('[data-bundle-line]')];
    this.total = this.querySelector('[data-bundle-total]');
    this.submit = this.querySelector('[data-bundle-submit]');
    this.message = this.querySelector('[data-bundle-message]');
    this.addEventListener('click', (event) => this.onClick(event));
    this.update();
  }

  onClick(event) {
    const quantityButton = event.target.closest('[data-quantity-change]');
    if (quantityButton) {
      const line = quantityButton.closest('[data-bundle-line]');
      const change = Number(quantityButton.dataset.quantityChange);
      const nextQuantity = Math.max(0, Math.min(12, Number(line.dataset.quantity) + change));
      line.dataset.quantity = String(nextQuantity);
      line.querySelector('[data-quantity-output]').textContent = String(nextQuantity);
      this.update();
      return;
    }
    if (event.target.closest('[data-bundle-submit]')) this.addToCart();
  }

  update() {
    const selected = this.lines.filter((line) => Number(line.dataset.quantity) > 0);
    const serumCount = selected.slice(1).reduce((sum, line) => sum + Number(line.dataset.quantity), 0);
    const deviceLine = this.lines[0];
    const total = Number(deviceLine.dataset.price) + this.serumTotal(serumCount);
    this.total.textContent = this.formatMoney(total);
    this.submit.disabled = serumCount === 0;
    this.message.textContent = serumCount === 0 ? 'Choose at least one serum.' : '';

    this.querySelectorAll('[data-tier]').forEach((tier) => {
      const tierNumber = Number(tier.dataset.tier);
      const activeTier = serumCount >= 3 ? 3 : Math.max(1, serumCount);
      tier.classList.toggle('is-active', tierNumber === activeTier);
      tier.classList.toggle('is-complete', tierNumber < activeTier);
    });
  }

  serumTotal(quantity) {
    if (quantity <= 0) return 0;
    return 1995 + (quantity >= 2 ? 1495 : 0) + Math.max(0, quantity - 2) * 995;
  }

  formatMoney(cents) {
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents, this.dataset.moneyFormat);
    return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(cents / 100);
  }

  async addToCart() {
    const serumCount = this.lines.slice(1).reduce((sum, line) => sum + Number(line.dataset.quantity), 0);
    const items = this.lines.filter((line) => Number(line.dataset.quantity) > 0).map((line) => ({
      id: Number(line.dataset.variantId),
      quantity: Number(line.dataset.quantity),
      properties: {
        _Bundle: 'Luminair personalised ritual',
        _BundleTier: `${serumCount} serum${serumCount === 1 ? '' : 's'} with progressive pricing`,
      },
    }));
    if (items.length < 2) return;
    this.submit.disabled = true;
    this.submit.setAttribute('aria-busy', 'true');
    this.message.textContent = 'Adding your bundle…';
    try {
      const response = await fetch(this.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add the bundle.');
      window.location.assign(this.dataset.cartUrl);
    } catch (error) {
      this.message.textContent = error.message;
      this.submit.disabled = false;
      this.submit.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('luminair-bundle')) customElements.define('luminair-bundle', LuminairBundle);

const mountLuminairBundle = () => {
  const template = document.querySelector('#luminair-bundle-source');
  const source = template?.content.querySelector('luminair-bundle');
  const pageFlyBundle = document.querySelector('.pf-176_');
  if (source && pageFlyBundle) {
    pageFlyBundle.replaceChildren(source.cloneNode(true));
    template.remove();
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountLuminairBundle, { once: true });
} else {
  mountLuminairBundle();
}
